const findAddressComponentMatch = (addressComponents, type) => addressComponents.find(({
  types = ['']
}) => types.includes(type));

window.googleMapsPromise = new Promise((resolve, reject) => {
  const resolveServices = () => {
    try {
      window.sessionToken = new window.google.maps.places.AutocompleteSessionToken();
      resolve({
        autocomplete: new window.google.maps.places.AutocompleteService(),
        places: new window.google.maps.places.PlacesService(document.createElement('div'))
      });
    } catch (error) {
      reject(error);
    }
  };

  if (typeof window.google !== 'undefined') {
    resolveServices();
  } else {
    window.googleMapsInitialised = () => {
      resolveServices();
    };
  }
});
export const getLocations = input => window.googleMapsPromise.then(({
  autocomplete
}) => autocomplete.getPlacePredictions({
  input,
  types: ['(cities)'],
  sessionToken: window.sessionToken,
  fields: ['description', 'place_id']
}).then(res => res.predictions));
export const selectLocation = placeId => new Promise((resolve, reject) => {
  window.googleMapsPromise.then(({
    places
  }) => places.getDetails({
    placeId,
    fields: ['geometry', 'address_components', 'formatted_address'],
    sessionToken: window.sessionToken
  }, place => {
    const country = findAddressComponentMatch(place.address_components, 'country');
    const state = country && country.short_name === 'US' ? findAddressComponentMatch(place.address_components, 'administrative_area_level_1') : undefined;
    const city = findAddressComponentMatch(place.address_components, 'locality');
    window.sessionToken = new window.google.maps.places.AutocompleteSessionToken();
    resolve({
      displayName: place.formatted_address,
      gplaceId: placeId,
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
      city: city ? city.long_name : undefined,
      country: country ? country.long_name : undefined,
      state: state ? state.long_name : undefined
    });
  })).catch(reject);
});